// extracted by mini-css-extract-plugin
export default {"scimSwitchWrapper":"SCIMSwitch_scimSwitchWrapper__xFRw6","switch":"SCIMSwitch_switch__iFyz3"};